import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Radio, Square } from 'lucide-react';
import { toast } from 'sonner';
import { getSession, subscribe, stopTracking } from '../native/backgroundTracker';

// Always-visible indicator while a load-tracking session is running, so the driver
// can see (and end) location sharing from anywhere in the app.
export const TrackingSessionBanner = () => {
  const [sess, setSess] = useState(getSession());
  const navigate = useNavigate();
  useEffect(() => subscribe(setSess), []);
  if (!sess.active) return null;
  return (
    <div data-testid="tracking-session-banner" className="mx-4 mt-4 md:mx-8 flex items-center justify-between gap-3 bg-emerald-50 border border-emerald-300 rounded-md px-3 py-2 text-xs text-emerald-900" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
      <button type="button" onClick={() => navigate('/live-tracking')} className="flex items-center gap-2 text-left">
        <Radio className="w-4 h-4 text-emerald-600 animate-pulse flex-shrink-0" />
        <span>
          <strong>Sharing your location with dispatch</strong>
          {sess.startedAt ? ` · since ${new Date(sess.startedAt).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}` : ''}
        </span>
      </button>
      <button type="button" data-testid="tracking-session-banner-stop" onClick={() => { stopTracking(); toast.info('Location sharing stopped'); }}
              className="inline-flex items-center gap-1 px-2.5 py-1 rounded bg-white border border-emerald-300 font-semibold text-emerald-800 hover:bg-emerald-100">
        <Square className="w-3 h-3" /> Stop
      </button>
    </div>
  );
};
